document.addEventListener("DOMContentLoaded", () => {
  const expandLink = document.getElementById("expand-link");
  const fullDescription = document.getElementById("full-product-description");

  if (!expandLink || !fullDescription) return;

  expandLink.addEventListener("click", (event) => {
    event.preventDefault();

    fullDescription.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  });
});